import { ENVIRONMENT_FLAGS } from '@client/utils/constants';

export function isLocalEnv (hostname) {
  return (hostname.includes('localhost'));
}

export function isDevEnv (hostname) {
  const devOrStagingEnv = /^alexandria.app.dev.newseladev.com/g;
  return (devOrStagingEnv.test(hostname));
}

export function isStagingEnv (hostname) {
  const devOrStagingEnv = /^alexandria.app.staging.newseladev.com/g;
  return (devOrStagingEnv.test(hostname));
}

export function isFeatureEnv (hostname) {
  const featureEnv = /\b(?!(?:alexandria)\b)(?!(?:app)\b)\w+[\w-]+\.dev\.newseladev\.com/g;
  return (featureEnv.test(hostname));
}

export function getEnvironmentFlags (hostname) {
  if (isLocalEnv(hostname)) {
    // Check DGRAPH_HOST env variable for dev/staging/prod
    const dgraphHost = (typeof process !== 'undefined' && process.env && process.env.DGRAPH_HOST) ? process.env.DGRAPH_HOST : null;

    if (dgraphHost) {
      const host = dgraphHost.toLowerCase();
      if (host.includes('dev')) {
        return ENVIRONMENT_FLAGS.dev;
      } else if (host.includes('staging')) {
        return ENVIRONMENT_FLAGS.staging;
      } else if (host.includes('prod')) {
        return ENVIRONMENT_FLAGS.prod ? ENVIRONMENT_FLAGS.prod : { name: 'PROD', color: 'red' };
      }
    }
    return ENVIRONMENT_FLAGS.local;
  } else if (isFeatureEnv(hostname)) {
    return ENVIRONMENT_FLAGS.feature;
  } else if (isStagingEnv(hostname)) {
    return ENVIRONMENT_FLAGS.staging;
  } else if (isDevEnv(hostname)) {
    return ENVIRONMENT_FLAGS.dev;
  }
}
